/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiAIModelFromJSON, ApiAIModelToJSON, } from './ApiAIModel';
export function InlineObjectFromJSON(json) {
    return InlineObjectFromJSONTyped(json, false);
}
export function InlineObjectFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'model': !exists(json, 'model') ? undefined : ApiAIModelFromJSON(json['model']),
        'modelName': !exists(json, 'modelName') ? undefined : json['modelName'],
        'overridePrompt': !exists(json, 'overridePrompt') ? undefined : json['overridePrompt'],
        'prompt': !exists(json, 'prompt') ? undefined : json['prompt'],
    };
}
export function InlineObjectToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'model': ApiAIModelToJSON(value.model),
        'modelName': value.modelName,
        'overridePrompt': value.overridePrompt,
        'prompt': value.prompt,
    };
}
